import { Link } from 'react-router-dom';
import type { ChapterItem, Manga } from '@/mocks/manga';

interface ChapterListProps {
  manga: Manga;
  chapters: ChapterItem[];
}

export default function ChapterList({ manga, chapters }: ChapterListProps) {
  return (
    <section className="rounded-lg bg-background-50 p-4 md:p-6" aria-label="章节列表">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="font-heading text-lg text-foreground-950 md:text-xl">
          章节列表
          <span className="ml-2 text-sm text-foreground-500">{chapters.length} 话</span>
        </h2>
        <span className="text-xs text-foreground-600">
          共 {manga.totalChapters} 话 · 新章节持续更新中
        </span>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
        {chapters.map((ch) => (
          <Link
            key={ch.id}
            to={`/read/${manga.id}/${ch.id}`}
            className="group flex items-center justify-between gap-2 rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            <span className="truncate">{ch.title}</span>
            <i
              className="ri-arrow-right-s-line shrink-0 text-foreground-400 transition-colors group-hover:text-background-50"
              aria-hidden="true"
            />
          </Link>
        ))}
      </div>
    </section>
  );
}